var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8 14"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M0 .93C0 .524.197.24.592.085c.394-.157.733-.094 1.017.188l6.107 6.07A.9.9 0 018 7a.9.9 0 01-.284.659l-6.107 6.069c-.284.282-.623.345-1.017.188-.395-.157-.592-.44-.592-.847V.931z"}})])};var toString = function () {return "/app/static/svg/tc_read_more.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./static/svg/tc_read_more.svg
// module id = 962
// module chunks = 6 77 86